<template>
  <div class="tongji-container">
    <!-- 筛选栏 -->
    <el-card class="filter-card">
      <el-form v-model="form" :inline="true" class="form">
        <el-form-item label="开始日期">
          <el-date-picker
            v-model="form.startDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="结束日期">
          <el-date-picker
            v-model="form.endDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label=" " class="button-item">
          <el-button type="primary" style="width: 100%" @click="handleQuery">
            查询统计
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 核心数据卡片 -->
    <el-row :gutter="20" class="stats-row">
      <el-col :span="6">
        <el-card class="stat-card">
          <div class="stat-label">活跃天数</div>
          <div class="stat-value text-primary">{{ data.activeDays }}</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stat-card">
          <div class="stat-label">人均活跃天数</div>
          <div class="stat-value text-success">{{ data.avgActiveDays }} 天</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stat-card">
          <div class="stat-label">打卡次数</div>
          <div class="stat-value text-info">{{ data.counts }}</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stat-card">
          <div class="stat-label">人均打卡次数</div>
          <div class="stat-value text-warning">{{ data.avgCounts }} 次/人</div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 图表区域：PAD使用 + 健康打卡 -->
    <el-row :gutter="20" class="chart-row">
      <el-col :span="12">
        <el-card class="chart-card">
          <div slot="header">
            <span>PAD每日使用次数</span>
          </div>
          <div ref="deviceChart" class="chart-container" style="height: 350px;" />
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="chart-card">
          <div slot="header">
            <span>PAD每日健康打卡人数</span>
          </div>
          <div ref="clockChart" class="chart-container" style="height: 350px;" />
        </el-card>
      </el-col>
    </el-row>

    <!-- 业务明细表格 -->
    <el-card class="table-card">
      <div slot="header">
        <span>PAD门店每日明细</span>
      </div>
      <el-table :data="tableData" border stripe style="width: 100%" show-summary :summary-method="getSummaries">
        <el-table-column prop="entryTime" label="日期" align="center" />
        <el-table-column prop="storeName" label="门店名称" align="center" />
        <el-table-column prop="dayCounts" label="使用次数" align="center" />
        <el-table-column prop="dayUsers" label="打卡人数" align="center" />
      </el-table>
    </el-card>

    <!-- 各门店使用次数对比 -->
    <el-card class="chart-card">
      <div slot="header">
        <span>各门店使用次数对比</span>
      </div>
      <div ref="totalClockChart" class="chart-container" style="height: 350px;" />
    </el-card>
  </div>
</template>

<script>
import { postData } from '@/api/user/authApi'
import * as echarts from 'echarts'

export default {
  name: 'PadUsageStore',
  data() {
    // 获取当月起止日期
    const now = new Date()
    const year = now.getFullYear()
    const month = String(now.getMonth() + 1).padStart(2, '0')
    const day = String(now.getDate()).padStart(2, '0')

    // 结束日期：今天
    const endDate = `${year}-${month}-${day}`

    // 开始日期：两个月前的1号（n-2月），自动处理跨年
    const start = new Date(now.getFullYear(), now.getMonth() - 2, 1)
    const startYear = start.getFullYear()
    const startMonth = String(start.getMonth() + 1).padStart(2, '0')
    const startDate = `${startYear}-${startMonth}-01`
    return {
      form: {
        startDate: startDate,
        endDate: endDate
      },
      data: {
        activeDays: 0,
        avgActiveDays: 0,
        counts: 0,
        avgCounts: 0
      },
      deviceChart: null,
      clockChart: null,
      totalClockChart: null,
      // 图表数据存储
      deviceChartData: {
        dates: [],
        values: []
      },
      clockChartData: {
        dates: [],
        values: []
      },
      totalClockChartData: {
        names: [],
        values: []
      },
      tableData: []
    }
  },
  mounted() {
    this.initCharts()
    window.addEventListener('resize', this.handleResize)
    // 页面加载时自动获取数据
    this.gettableData()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    this.disposeCharts()
  },
  methods: {
    initCharts() {
      this.initDeviceChart()
      this.initClockChart()
      this.initTotalClockChart()
    },
    disposeCharts() {
      if (this.deviceChart) this.deviceChart.dispose()
      if (this.clockChart) this.clockChart.dispose()
      if (this.totalClockChart) this.totalClockChart.dispose()
    },
    // 获取表格和图表数据
    gettableData() {
      const storeId = this.$store.getters['user/getStoreId']
      const p = {
        startTime: this.form.startDate + ' 00:00:00',
        endTime: this.form.endDate + ' 23:59:59',
        storeId: storeId
      }
      postData('daocui-board/board/pad/padboard/find/paddatastatistics', p).then(res => {
        console.log(res)
        const d = res.data || {}
        // 更新核心统计数据（对接真实字段）
        this.data.activeDays = d.allDays || 0
        this.data.avgActiveDays = d.avgDays || 0
        this.data.counts = d.allCounts || 0
        this.data.avgCounts = d.avgCounts || 0

        // 处理表格数据（使用 padDayStore）
        if (d.padDayStore && Array.isArray(d.padDayStore)) {
          this.tableData = d.padDayStore
        } else {
          this.tableData = []
        }

        // 处理图表1：每日总使用次数（从 padDayStore 按日期聚合 dayCounts）
        if (d.padDayStore && Array.isArray(d.padDayStore)) {
          this.processDeviceChartData(d.padDayStore)
        }

        // 处理图表2：每日打卡人数（使用 padDayUsers）
        if (d.padDayUsers && Array.isArray(d.padDayUsers)) {
          this.processClockChartData(d.padDayUsers)
        }

        // 处理图表3：各门店使用次数对比（从 padDayStore 按门店聚合）
        if (d.padDayStore && Array.isArray(d.padDayStore)) {
          this.processTotalClockChartData(d.padDayStore)
        }
      }).catch(error => {
        console.error('获取PAD统计数据失败:', error)
        this.$message?.error('获取统计数据失败')
      })
    },
    // 处理PAD使用图表数据：按日期汇总 dayCounts
    processDeviceChartData(padDayStore) {
      const dateMap = {}
      padDayStore.forEach(item => {
        const date = item.entryTime
        if (!dateMap[date]) {
          dateMap[date] = 0
        }
        dateMap[date] += item.dayCounts || 0
      })
      const sortedEntries = Object.entries(dateMap).sort((a, b) => new Date(a[0]) - new Date(b[0]))
      this.deviceChartData.dates = sortedEntries.map(item => item[0])
      this.deviceChartData.values = sortedEntries.map(item => item[1])
      this.updateDeviceChart()
    },
    // 处理打卡人数图表数据：直接使用 padDayUsers
    processClockChartData(padDayUsers) {
      const sorted = [...padDayUsers].sort((a, b) => new Date(a.entryTime) - new Date(b.entryTime))
      this.clockChartData.dates = sorted.map(item => item.entryTime)
      this.clockChartData.values = sorted.map(item => item.dayUsers || 0)
      this.updateClockChart()
    },
    // 处理各门店使用次数对比：按 storeName 聚合 dayCounts
    processTotalClockChartData(padDayStore) {
      const storeMap = {}
      padDayStore.forEach(item => {
        const name = item.storeName || '未知门店'
        if (!storeMap[name]) {
          storeMap[name] = 0
        }
        storeMap[name] += item.dayCounts || 0
      })
      // 按使用次数降序
      const sortedEntries = Object.entries(storeMap).sort((a, b) => b[1] - a[1])
      this.totalClockChartData.names = sortedEntries.map(item => item[0])
      this.totalClockChartData.values = sortedEntries.map(item => item[1])
      this.updateTotalClockChart()
    },
    // PAD使用次数柱状图
    initDeviceChart() {
      this.deviceChart = echarts.init(this.$refs.deviceChart)
      const option = {
        title: {
          text: '暂无数据',
          left: 'center',
          top: 'center',
          textStyle: { color: '#909399' }
        },
        xAxis: { type: 'category', data: [] },
        yAxis: { type: 'value' },
        series: []
      }
      this.deviceChart.setOption(option)
    },
    updateDeviceChart() {
      const option = {
        title: { show: false },
        tooltip: {
          trigger: 'axis',
          formatter: '{b} <br/>使用次数: {c} 次'
        },
        grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
        xAxis: {
          type: 'category',
          data: this.deviceChartData.dates,
          name: '日期',
          axisLabel: { rotate: 45 }
        },
        yAxis: {
          type: 'value',
          name: '使用次数',
          minInterval: 1
        },
        series: [{
          name: 'PAD使用次数',
          type: 'bar',
          data: this.deviceChartData.values,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#36A2EB' },
              { offset: 1, color: '#4BC0C0' }
            ])
          },
          barWidth: '60%'
        }]
      }
      this.deviceChart.setOption(option, true)
    },
    // 健康打卡柱状图
    initClockChart() {
      this.clockChart = echarts.init(this.$refs.clockChart)
      const option = {
        title: {
          text: '暂无数据',
          left: 'center',
          top: 'center',
          textStyle: { color: '#909399' }
        },
        xAxis: { type: 'category', data: [] },
        yAxis: { type: 'value' },
        series: []
      }
      this.clockChart.setOption(option)
    },
    updateClockChart() {
      const option = {
        title: { show: false },
        tooltip: {
          trigger: 'axis',
          formatter: '{b} <br/>打卡人数: {c} 人'
        },
        grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
        xAxis: {
          type: 'category',
          data: this.clockChartData.dates,
          name: '日期',
          axisLabel: { rotate: 45 }
        },
        yAxis: {
          type: 'value',
          name: '打卡人数',
          minInterval: 1
        },
        series: [{
          name: '打卡人数',
          type: 'bar',
          data: this.clockChartData.values,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#FF6384' },
              { offset: 1, color: '#FFCE56' }
            ])
          },
          barWidth: '60%'
        }]
      }
      this.clockChart.setOption(option, true)
    },
    // 各门店使用次数对比柱状图
    initTotalClockChart() {
      this.totalClockChart = echarts.init(this.$refs.totalClockChart)
      const option = {
        title: {
          text: '暂无数据',
          left: 'center',
          top: 'center',
          textStyle: { color: '#909399' }
        },
        xAxis: { type: 'category', data: [] },
        yAxis: { type: 'value' },
        series: []
      }
      this.totalClockChart.setOption(option)
    },
    updateTotalClockChart() {
      const option = {
        title: { show: false },
        tooltip: {
          trigger: 'axis',
          formatter: '{b} <br/>使用次数: {c} 次'
        },
        grid: { left: '3%', right: '4%', bottom: '10%', containLabel: true },
        xAxis: {
          type: 'category',
          data: this.totalClockChartData.names,
          name: '门店',
          axisLabel: { rotate: 30, interval: 0 }
        },
        yAxis: {
          type: 'value',
          name: '使用次数',
          beginAtZero: true,
          minInterval: 1
        },
        series: [{
          name: '使用次数',
          type: 'bar',
          data: this.totalClockChartData.values,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#4BC0C0' },
              { offset: 1, color: '#36A2EB' }
            ])
          },
          barWidth: '50%'
        }]
      }
      this.totalClockChart.setOption(option, true)
    },
    handleQuery() {
      // 重新查询数据
      this.gettableData()
    },
    handleResize() {
      if (this.deviceChart) this.deviceChart.resize()
      if (this.clockChart) this.clockChart.resize()
      if (this.totalClockChart) this.totalClockChart.resize()
    },
    // 表格汇总方法
    getSummaries(param) {
      const { columns, data } = param
      const sums = []

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (index === 1) {
          sums[index] = ''
          return
        }

        const values = data.map(item => Number(item[column.property]))
        const sum = values.reduce((prev, curr) => {
          const value = Number(curr)
          if (!isNaN(value)) {
            return prev + value
          }
          return prev
        }, 0)

        sums[index] = sum
      })

      return sums
    }
  }
}
</script>

<style scoped>
.tongji-container {
  padding: 20px;
  background-color: #f5f7fa;
  height: calc(100vh - 50px);
  overflow: auto;
}
.form {
  display: flex;
  justify-content: center;
  align-items: center;
}
.filter-card {
  margin-bottom: 20px;
}
.button-item {
  margin-bottom: 0;
  display: flex;
  align-items: flex-end;
}
.stats-row {
  margin-bottom: 20px;
}
.stat-card {
  text-align: center;
  padding: 10px;
}
.stat-label {
  font-size: 14px;
  color: #606266;
  margin-bottom: 10px;
}
.stat-value {
  font-size: 28px;
  font-weight: bold;
}
.text-primary { color: #409EFF; }
.text-success { color: #67C23A; }
.text-info { color: #909399; }
.text-warning { color: #E6A23C; }
.chart-row {
  margin-bottom: 20px;
}
.chart-card {
  margin-bottom: 20px;
}
.chart-container {
  width: 100%;
}
.table-card {
  margin-bottom: 20px;
}

/* 汇总行样式 */
>>> .el-table__footer-wrapper .el-table__footer td {
  font-weight: bold;
  background-color: #f5f7fa;
  white-space: pre-line;
  line-height: 1.5;
}
</style>
